module.exports = __webpack_public_path__ + "img/Freiblick_Logo_mit_Claim_4c.a9c3ce8f.png";